const AIExample = {
  v: "4.8.0",
  meta: { g: "LottieFiles AE 3.5.2", a: "", k: "", d: "", tc: "" },
  fr: 60,
  ip: 0,
  op: 400,
  w: 782.75,
  h: 598.249962332379,
  nm: "ai-beta-launch 2x",
  ddd: 0,
  assets: [
    {
      id: "image_0",
      w: 66,
      h: 66,
      u: "",
      p:
        "data:image/png;base64,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",
      e: 1,
    },
    {
      id: "comp_0",
      layers: [
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "Ask me anything 2 Outlines",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [146.266, 266.978, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-49.485, -0.546],
                        [-48.545, -3.192],
                        [-44.768, -3.192],
                        [-43.828, -0.546],
                        [-42.642, -0.546],
                        [-46.073, -9.89],
                        [-47.241, -9.89],
                        [-50.672, -0.546],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "A",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-48.19, -4.196],
                        [-46.693, -8.411],
                        [-46.62, -8.411],
                        [-45.124, -4.196],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "A",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "mm",
                  mm: 1,
                  nm: "Merge Paths 1",
                  mn: "ADBE Vector Filter - Merge",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: {
                    a: 0,
                    k: [0.658330042222, 0.658330042222, 0.658330042222, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "A",
              np: 5,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [1.387, 0],
                        [0, -1.186],
                        [-1.287, -0.301],
                        [0, 0],
                        [0, -0.484],
                        [1.004, 0],
                        [0.192, 0.753],
                        [0, 0],
                        [-1.433, 0],
                        [0, 1.209],
                        [1.25, 0.306],
                        [0, 0],
                        [0, 0.538],
                        [-0.858, 0],
                        [-0.187, -0.484],
                      ],
                      o: [
                        [-0.338, -0.995],
                        [-1.478, 0],
                        [0, 0.967],
                        [0, 0],
                        [0.707, 0.164],
                        [0, 0.602],
                        [-0.881, 0],
                        [0, 0],
                        [0.251, 1.191],
                        [1.629, 0],
                        [0, -0.976],
                        [0, 0],
                        [-0.83, -0.205],
                        [0, -0.602],
                        [0.94, 0],
                        [0, 0],
                      ],
                      v: [
                        [-36.261, -5.984],
                        [-38.743, -7.645],
                        [-41.316, -5.619],
                        [-39.455, -3.703],
                        [-38.287, -3.429],
                        [-37.246, -2.444],
                        [-38.889, -1.349],
                        [-40.513, -2.48],
                        [-41.535, -2.225],
                        [-38.871, -0.4],
                        [-36.133, -2.498],
                        [-37.995, -4.396],
                        [-39.035, -4.652],
                        [-40.239, -5.674],
                        [-38.743, -6.714],
                        [-37.228, -5.71],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "s",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: {
                    a: 0,
                    k: [0.658330042222, 0.658330042222, 0.658330042222, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "s",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-34.429, -0.546],
                        [-33.353, -0.546],
                        [-33.353, -3.169],
                        [-32.6, -3.867],
                        [-29.976, -0.546],
                        [-28.608, -0.546],
                        [-31.788, -4.561],
                        [-28.827, -7.554],
                        [-30.159, -7.554],
                        [-33.225, -4.433],
                        [-33.353, -4.433],
                        [-33.353, -9.89],
                        [-34.429, -9.89],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "k",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: {
                    a: 0,
                    k: [0.658330042222, 0.658330042222, 0.658330042222, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "k",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 3,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.839, 0],
                        [0, -0.798],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.985, 0],
                        [0, -1.036],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [1.25, 0],
                        [0.36, -0.725],
                        [0, 0],
                        [0.922, 0],
                        [0.292, -0.748],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, -1.027],
                        [0.817, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -0.903],
                        [0.766, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -1.647],
                        [-1.004, 0],
                        [0, 0],
                        [-0.347, -0.748],
                        [-0.912, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-23.701, -0.546],
                        [-22.624, -0.546],
                        [-22.624, -4.926],
                        [-21.036, -6.678],
                        [-19.649, -5.345],
                        [-19.649, -0.546],
                        [-18.554, -0.546],
                        [-18.554, -5.108],
                        [-17.003, -6.678],
                        [-15.58, -5.236],
                        [-15.58, -0.546],
                        [-14.503, -0.546],
                        [-14.503, -5.236],
                        [-16.638, -7.645],
                        [-18.737, -6.459],
                        [-18.81, -6.459],
                        [-20.689, -7.645],
                        [-22.569, -6.459],
                        [-22.66, -6.459],
                        [-22.66, -7.554],
                        [-23.701, -7.554],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "m",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: {
                    a: 0,
                    k: [0.658330042222, 0.658330042222, 0.658330042222, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "m",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 4,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-2.026, 0],
                        [-0.328, 1.058],
                        [0, 0],
                        [0.844, 0],
                        [0.05, 1.501],
                        [0, 0],
                        [0, 0],
                        [1.46, 0],
                        [0, -2.153],
                      ],
                      o: [
                        [1.423, 0],
                        [0, 0],
                        [-0.274, 0.73],
                        [-1.264, 0],
                        [0, 0],
                        [0, 0],
                        [0, -2.61],
                        [-1.898, 0],
                        [0, 2.153],
                      ],
                      v: [
                        [-9.461, -0.4],
                        [-6.669, -2.17],
                        [-7.709, -2.462],
                        [-9.461, -1.367],
                        [-11.647, -3.685],
                        [-6.56, -3.685],
                        [-6.56, -4.141],
                        [-9.571, -7.645],
                        [-12.728, -3.995],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "e",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-1.232, 0],
                        [0, -1.186],
                      ],
                      o: [
                        [0.073, -1.09],
                        [1.168, 0],
                        [0, 0],
                      ],
                      v: [
                        [-11.647, -4.615],
                        [-9.571, -6.678],
                        [-7.655, -4.615],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "e",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "mm",
                  mm: 1,
                  nm: "Merge Paths 1",
                  mn: "ADBE Vector Filter - Merge",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: {
                    a: 0,
                    k: [0.658330042222, 0.658330042222, 0.658330042222, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "e",
              np: 5,
              cix: 2,
              bm: 0,
              ix: 5,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-1.332, 0],
                        [-0.219, 0.456],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.894, 0],
                        [0.547, -1.277],
                        [0, 0],
                        [-1.027, 0],
                        [0, -0.899],
                        [0, 0],
                        [1.277, -0.164],
                        [0, -1.606],
                      ],
                      o: [
                        [1.223, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -2.226],
                        [-1.058, 0],
                        [0, 0],
                        [0.237, -0.511],
                        [0.99, 0],
                        [0, 0],
                        [0, 0.52],
                        [-1.3, 0.169],
                        [0, 1.369],
                      ],
                      v: [
                        [0.89, -0.382],
                        [2.97, -1.495],
                        [3.025, -1.495],
                        [3.025, -0.546],
                        [4.102, -0.546],
                        [4.102, -5.163],
                        [1.51, -7.645],
                        [-1.3, -6.002],
                        [-0.278, -5.637],
                        [1.547, -6.696],
                        [3.025, -5.272],
                        [3.025, -5.236],
                        [1.218, -4.597],
                        [-1.501, -2.535],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "a",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [1.277, 0],
                        [0, 0.748],
                        [-0.839, 0.109],
                        [-0.182, 0.219],
                        [0, 0],
                      ],
                      o: [
                        [-0.858, 0],
                        [0, -0.821],
                        [0.456, -0.055],
                        [0, 0],
                        [0, 0.876],
                      ],
                      v: [
                        [1.054, -1.349],
                        [-0.424, -2.48],
                        [1.164, -3.666],
                        [3.025, -4.068],
                        [3.025, -3.082],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "a",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "mm",
                  mm: 1,
                  nm: "Merge Paths 1",
                  mn: "ADBE Vector Filter - Merge",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: {
                    a: 0,
                    k: [0.658330042222, 0.658330042222, 0.658330042222, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "a",
              np: 5,
              cix: 2,
              bm: 0,
              ix: 6,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-1.031, 0],
                        [0, -1.1],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [1.419, 0],
                        [0.328, -0.712],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, -1.223],
                        [0.999, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -1.788],
                        [-1.058, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [7.235, -4.761],
                        [9.024, -6.678],
                        [10.63, -4.926],
                        [10.63, -0.546],
                        [11.707, -0.546],
                        [11.707, -4.999],
                        [9.334, -7.645],
                        [7.29, -6.459],
                        [7.199, -6.459],
                        [7.199, -7.554],
                        [6.159, -7.554],
                        [6.159, -0.546],
                        [7.235, -0.546],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "n",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: {
                    a: 0,
                    k: [0.658330042222, 0.658330042222, 0.658330042222, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "n",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 7,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-0.365, 0],
                        [-0.406, 1.09],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.785, 0.201],
                        [0, 0],
                      ],
                      o: [
                        [0.972, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.392, 1.068],
                        [0, 0],
                        [0.109, 0.055],
                      ],
                      v: [
                        [14.202, 2.082],
                        [16.264, 0.476],
                        [19.239, -7.554],
                        [18.071, -7.554],
                        [16.136, -1.969],
                        [16.063, -1.969],
                        [14.129, -7.554],
                        [12.961, -7.554],
                        [15.552, -0.509],
                        [15.351, 0.038],
                        [13.691, 1.005],
                        [13.417, 1.954],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "y",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: {
                    a: 0,
                    k: [0.658330042222, 0.658330042222, 0.658330042222, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "y",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 8,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.912, 0],
                        [-0.146, 0.055],
                        [0, 0],
                        [0.237, 0],
                        [0, 0.912],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 1.223],
                        [0.401, 0],
                        [0, 0],
                        [-0.091, 0.018],
                        [-0.474, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [23.795, -7.554],
                        [22.298, -7.554],
                        [22.298, -9.233],
                        [21.221, -9.233],
                        [21.221, -7.554],
                        [20.163, -7.554],
                        [20.163, -6.641],
                        [21.221, -6.641],
                        [21.221, -2.261],
                        [23.119, -0.455],
                        [23.922, -0.582],
                        [23.703, -1.549],
                        [23.229, -1.495],
                        [22.298, -2.553],
                        [22.298, -6.641],
                        [23.795, -6.641],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "t",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: {
                    a: 0,
                    k: [0.658330042222, 0.658330042222, 0.658330042222, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "t",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 9,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-1.063, 0],
                        [0, -1.113],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [1.433, 0],
                        [0.328, -0.725],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, -1.223],
                        [1.013, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -1.802],
                        [-1.104, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [26.699, -4.761],
                        [28.542, -6.678],
                        [30.166, -4.926],
                        [30.166, -0.546],
                        [31.243, -0.546],
                        [31.243, -4.999],
                        [28.852, -7.645],
                        [26.79, -6.459],
                        [26.699, -6.459],
                        [26.699, -9.89],
                        [25.622, -9.89],
                        [25.622, -0.546],
                        [26.699, -0.546],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "h",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: {
                    a: 0,
                    k: [0.658330042222, 0.658330042222, 0.658330042222, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "h",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 10,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [33.304, -0.546],
                        [34.38, -0.546],
                        [34.38, -7.554],
                        [33.304, -7.554],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "i",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-0.42, 0],
                        [0, 0.401],
                        [0.42, 0],
                        [0, -0.401],
                      ],
                      o: [
                        [0.42, 0],
                        [0, -0.401],
                        [-0.42, 0],
                        [0, 0.401],
                      ],
                      v: [
                        [33.851, -8.722],
                        [34.618, -9.452],
                        [33.851, -10.182],
                        [33.085, -9.452],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "i",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "mm",
                  mm: 1,
                  nm: "Merge Paths 1",
                  mn: "ADBE Vector Filter - Merge",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: {
                    a: 0,
                    k: [0.658330042222, 0.658330042222, 0.658330042222, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "i",
              np: 5,
              cix: 2,
              bm: 0,
              ix: 11,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [-1.031, 0],
                        [0, -1.1],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [1.419, 0],
                        [0.328, -0.712],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, -1.223],
                        [0.999, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -1.788],
                        [-1.058, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [37.464, -4.761],
                        [39.253, -6.678],
                        [40.859, -4.926],
                        [40.859, -0.546],
                        [41.935, -0.546],
                        [41.935, -4.999],
                        [39.563, -7.645],
                        [37.519, -6.459],
                        [37.428, -6.459],
                        [37.428, -7.554],
                        [36.387, -7.554],
                        [36.387, -0.546],
                        [37.464, -0.546],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "n",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: {
                    a: 0,
                    k: [0.658330042222, 0.658330042222, 0.658330042222, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "n",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 12,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-1.565, 0],
                        [0, 1.807],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [1.369, 0],
                        [0, -2.153],
                        [-1.697, 0],
                        [-0.237, 0.383],
                        [0, 0],
                        [0, 0],
                        [1.131, 0],
                        [0.287, 0.388],
                        [0, 0],
                      ],
                      o: [
                        [1.679, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.237, -0.365],
                        [-1.77, 0],
                        [0, 2.19],
                        [1.369, 0],
                        [0, 0],
                        [0, 0],
                        [0, 1.168],
                        [-1.273, 0],
                        [0, 0],
                        [0.438, 0.735],
                      ],
                      v: [
                        [46.824, 2.228],
                        [49.854, -0.345],
                        [49.854, -7.554],
                        [48.813, -7.554],
                        [48.813, -6.44],
                        [48.704, -6.44],
                        [46.66, -7.645],
                        [43.667, -4.086],
                        [46.642, -0.655],
                        [48.686, -1.841],
                        [48.777, -1.841],
                        [48.777, -0.418],
                        [46.824, 1.279],
                        [44.817, 0.221],
                        [43.959, 0.823],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "g",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [1.296, 0],
                        [0, 1.46],
                        [-1.369, 0],
                        [0, -1.515],
                      ],
                      o: [
                        [-1.35, 0],
                        [0, -1.423],
                        [1.314, 0],
                        [0, 1.551],
                      ],
                      v: [
                        [46.788, -1.622],
                        [44.744, -4.104],
                        [46.788, -6.678],
                        [48.795, -4.104],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "g",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "mm",
                  mm: 1,
                  nm: "Merge Paths 1",
                  mn: "ADBE Vector Filter - Merge",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: {
                    a: 0,
                    k: [0.658330042222, 0.658330042222, 0.658330042222, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "g",
              np: 5,
              cix: 2,
              bm: 0,
              ix: 13,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 1080,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: "icon",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: -180, ix: 10 },
            p: { a: 0, k: [346.444, 260.217, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [-100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-0.159, -0.159],
                        [-0.236, 0],
                        [0, 0],
                        [-0.966, 0.875],
                        [0, 1.306],
                        [0.965, 0.875],
                        [1.347, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0.236],
                        [0.153, 0.153],
                        [0.236, 0],
                        [0.153, -0.153],
                        [0, 0],
                        [0.035, -0.097],
                        [0, -0.111],
                        [-0.034, -0.097],
                        [-0.083, -0.083],
                        [0, 0],
                        [-0.236, 0],
                        [-0.153, 0.153],
                        [0, 0.236],
                        [0.153, 0.153],
                        [0, 0],
                        [0, 0],
                        [-0.646, -0.556],
                        [0, -0.833],
                        [0.646, -0.556],
                        [0.875, 0],
                        [0, 0],
                        [0.16, -0.16],
                        [0, -0.236],
                      ],
                      o: [
                        [0.16, 0.16],
                        [0, 0],
                        [1.347, 0],
                        [0.965, -0.875],
                        [0, -1.306],
                        [-0.966, -0.875],
                        [0, 0],
                        [0, 0],
                        [0.153, -0.153],
                        [0, -0.236],
                        [-0.153, -0.153],
                        [-0.236, 0],
                        [0, 0],
                        [-0.083, 0.083],
                        [-0.034, 0.097],
                        [0, 0.111],
                        [0.035, 0.097],
                        [0, 0],
                        [0.153, 0.153],
                        [0.236, 0],
                        [0.153, -0.153],
                        [0, -0.236],
                        [0, 0],
                        [0, 0],
                        [0.875, 0],
                        [0.646, 0.556],
                        [0, 0.833],
                        [-0.646, 0.556],
                        [0, 0],
                        [-0.236, 0],
                        [-0.159, 0.159],
                        [0, 0.236],
                      ],
                      v: [
                        [-4.105, 5.833],
                        [-3.51, 6.073],
                        [1.573, 6.073],
                        [5.042, 4.76],
                        [6.49, 1.49],
                        [5.042, -1.781],
                        [1.573, -3.094],
                        [-3.677, -3.094],
                        [-2.094, -4.677],
                        [-1.865, -5.26],
                        [-2.094, -5.844],
                        [-2.677, -6.073],
                        [-3.26, -5.844],
                        [-6.26, -2.844],
                        [-6.438, -2.573],
                        [-6.49, -2.26],
                        [-6.438, -1.948],
                        [-6.26, -1.677],
                        [-3.26, 1.323],
                        [-2.677, 1.552],
                        [-2.094, 1.323],
                        [-1.865, 0.74],
                        [-2.094, 0.156],
                        [-3.677, -1.427],
                        [1.573, -1.427],
                        [3.854, -0.594],
                        [4.823, 1.49],
                        [3.854, 3.573],
                        [1.573, 4.406],
                        [-3.51, 4.406],
                        [-4.105, 4.646],
                        [-4.344, 5.24],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: {
                    a: 0,
                    k: [0.458823531866, 0.458823531866, 0.458823531866, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "undo",
              np: 2,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 1080,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 5,
          ty: 4,
          nm: "box",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [225.766, 260.978, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ty: "rc",
                  d: 1,
                  s: { a: 0, k: [293, 46], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 8, ix: 4 },
                  nm: "Rectangle Path 1",
                  mn: "ADBE Vector Shape - Rect",
                  hd: false,
                },
                {
                  ty: "st",
                  c: {
                    a: 0,
                    k: [0.658333361149, 0.658333361149, 0.658333361149, 1],
                    ix: 3,
                  },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 1, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Input",
              np: 2,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 1080,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 6,
          ty: 0,
          nm: "cw-response",
          refId: "comp_1",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 216,
                  s: [0],
                },
                { t: 236, s: [100] },
              ],
              ix: 11,
              x:
                "var $bm_rt;\nfunction easeandwizz_inoutQuart(t, b, c, d) {\n    if ((t /= d / 2) < 1)\n        return $bm_sum($bm_mul($bm_mul($bm_mul($bm_mul($bm_div(c, 2), t), t), t), t), b);\n    return $bm_sum($bm_mul($bm_div($bm_neg(c), 2), $bm_sub($bm_mul($bm_mul($bm_mul(t -= 2, t), t), t), 2)), b);\n}\nfunction easeAndWizz() {\n    var t, d, sX, eX;\n    var n = 0;\n    if (numKeys > 0) {\n        n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    try {\n        var key1 = key(n);\n        var key2 = key($bm_sum(n, 1));\n    } catch (e) {\n        return null;\n    }\n    t = $bm_sub(time, key1.time);\n    d = $bm_sub(key2.time, key1.time);\n    sX = key1.time;\n    eX = $bm_sub(key2.time, key1.time);\n    if (time < key1.time || time > key2.time) {\n        return null;\n    } else {\n        return valueAtTime(easeandwizz_inoutQuart(t, sX, eX, d));\n    }\n}\n$bm_rt = easeAndWizz() || value;",
            },
            r: { a: 0, k: 0, ix: 10 },
            p: {
              a: 0,
              k: [137.431, 206.503, 0],
              ix: 2,
              x:
                "var $bm_rt;\nfunction easeandwizz_inoutQuart(t, b, c, d) {\n    if ((t /= d / 2) < 1)\n        return $bm_sum($bm_mul($bm_mul($bm_mul($bm_mul($bm_div(c, 2), t), t), t), t), b);\n    return $bm_sum($bm_mul($bm_div($bm_neg(c), 2), $bm_sub($bm_mul($bm_mul($bm_mul(t -= 2, t), t), t), 2)), b);\n}\nfunction easeAndWizz() {\n    var t, d, sX, eX;\n    var n = 0;\n    if (numKeys > 0) {\n        n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    try {\n        var key1 = key(n);\n        var key2 = key($bm_sum(n, 1));\n    } catch (e) {\n        return null;\n    }\n    t = $bm_sub(time, key1.time);\n    d = $bm_sub(key2.time, key1.time);\n    sX = key1.time;\n    eX = $bm_sub(key2.time, key1.time);\n    if (time < key1.time || time > key2.time) {\n        return null;\n    } else {\n        return valueAtTime(easeandwizz_inoutQuart(t, sX, eX, d));\n    }\n}\n$bm_rt = easeAndWizz() || value;",
            },
            a: { a: 0, k: [61, 19.5, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          w: 122,
          h: 39,
          ip: 0,
          op: 1080,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 7,
          ty: 0,
          nm: "dan-btm",
          refId: "comp_2",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 134,
                  s: [0],
                },
                { t: 154, s: [100] },
              ],
              ix: 11,
              x:
                "var $bm_rt;\nfunction easeandwizz_inoutQuart(t, b, c, d) {\n    if ((t /= d / 2) < 1)\n        return $bm_sum($bm_mul($bm_mul($bm_mul($bm_mul($bm_div(c, 2), t), t), t), t), b);\n    return $bm_sum($bm_mul($bm_div($bm_neg(c), 2), $bm_sub($bm_mul($bm_mul($bm_mul(t -= 2, t), t), t), 2)), b);\n}\nfunction easeAndWizz() {\n    var t, d, sX, eX;\n    var n = 0;\n    if (numKeys > 0) {\n        n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    try {\n        var key1 = key(n);\n        var key2 = key($bm_sum(n, 1));\n    } catch (e) {\n        return null;\n    }\n    t = $bm_sub(time, key1.time);\n    d = $bm_sub(key2.time, key1.time);\n    sX = key1.time;\n    eX = $bm_sub(key2.time, key1.time);\n    if (time < key1.time || time > key2.time) {\n        return null;\n    } else {\n        return valueAtTime(easeandwizz_inoutQuart(t, sX, eX, d));\n    }\n}\n$bm_rt = easeAndWizz() || value;",
            },
            r: { a: 0, k: 0, ix: 10 },
            p: {
              a: 0,
              k: [185, 159, 0],
              ix: 2,
              x:
                "var $bm_rt;\nfunction easeandwizz_inoutQuart(t, b, c, d) {\n    if ((t /= d / 2) < 1)\n        return $bm_sum($bm_mul($bm_mul($bm_mul($bm_mul($bm_div(c, 2), t), t), t), t), b);\n    return $bm_sum($bm_mul($bm_div($bm_neg(c), 2), $bm_sub($bm_mul($bm_mul($bm_mul(t -= 2, t), t), t), 2)), b);\n}\nfunction easeAndWizz() {\n    var t, d, sX, eX;\n    var n = 0;\n    if (numKeys > 0) {\n        n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    try {\n        var key1 = key(n);\n        var key2 = key($bm_sum(n, 1));\n    } catch (e) {\n        return null;\n    }\n    t = $bm_sub(time, key1.time);\n    d = $bm_sub(key2.time, key1.time);\n    sX = key1.time;\n    eX = $bm_sub(key2.time, key1.time);\n    if (time < key1.time || time > key2.time) {\n        return null;\n    } else {\n        return valueAtTime(easeandwizz_inoutQuart(t, sX, eX, d));\n    }\n}\n$bm_rt = easeAndWizz() || value;",
            },
            a: { a: 0, k: [191.5, 22.5, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          w: 383,
          h: 45,
          ip: 0,
          op: 1080,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 8,
          ty: 0,
          nm: "dan-2",
          refId: "comp_3",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 62,
                  s: [0],
                },
                { t: 82, s: [100] },
              ],
              ix: 11,
              x:
                "var $bm_rt;\nfunction easeandwizz_inoutQuart(t, b, c, d) {\n    if ((t /= d / 2) < 1)\n        return $bm_sum($bm_mul($bm_mul($bm_mul($bm_mul($bm_div(c, 2), t), t), t), t), b);\n    return $bm_sum($bm_mul($bm_div($bm_neg(c), 2), $bm_sub($bm_mul($bm_mul($bm_mul(t -= 2, t), t), t), 2)), b);\n}\nfunction easeAndWizz() {\n    var t, d, sX, eX;\n    var n = 0;\n    if (numKeys > 0) {\n        n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    try {\n        var key1 = key(n);\n        var key2 = key($bm_sum(n, 1));\n    } catch (e) {\n        return null;\n    }\n    t = $bm_sub(time, key1.time);\n    d = $bm_sub(key2.time, key1.time);\n    sX = key1.time;\n    eX = $bm_sub(key2.time, key1.time);\n    if (time < key1.time || time > key2.time) {\n        return null;\n    } else {\n        return valueAtTime(easeandwizz_inoutQuart(t, sX, eX, d));\n    }\n}\n$bm_rt = easeAndWizz() || value;",
            },
            r: { a: 0, k: 0, ix: 10 },
            p: {
              a: 0,
              k: [180, 106, 0],
              ix: 2,
              x:
                "var $bm_rt;\nfunction easeandwizz_inoutQuart(t, b, c, d) {\n    if ((t /= d / 2) < 1)\n        return $bm_sum($bm_mul($bm_mul($bm_mul($bm_mul($bm_div(c, 2), t), t), t), t), b);\n    return $bm_sum($bm_mul($bm_div($bm_neg(c), 2), $bm_sub($bm_mul($bm_mul($bm_mul(t -= 2, t), t), t), 2)), b);\n}\nfunction easeAndWizz() {\n    var t, d, sX, eX;\n    var n = 0;\n    if (numKeys > 0) {\n        n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    try {\n        var key1 = key(n);\n        var key2 = key($bm_sum(n, 1));\n    } catch (e) {\n        return null;\n    }\n    t = $bm_sub(time, key1.time);\n    d = $bm_sub(key2.time, key1.time);\n    sX = key1.time;\n    eX = $bm_sub(key2.time, key1.time);\n    if (time < key1.time || time > key2.time) {\n        return null;\n    } else {\n        return valueAtTime(easeandwizz_inoutQuart(t, sX, eX, d));\n    }\n}\n$bm_rt = easeAndWizz() || value;",
            },
            a: { a: 0, k: [194.5, 23, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          w: 389,
          h: 46,
          ip: 0,
          op: 1080,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 9,
          ty: 0,
          nm: "dan-top",
          refId: "comp_4",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 0,
                  s: [0],
                },
                { t: 20, s: [100] },
              ],
              ix: 11,
              x:
                "var $bm_rt;\nfunction easeandwizz_inoutQuart(t, b, c, d) {\n    if ((t /= d / 2) < 1)\n        return $bm_sum($bm_mul($bm_mul($bm_mul($bm_mul($bm_div(c, 2), t), t), t), t), b);\n    return $bm_sum($bm_mul($bm_div($bm_neg(c), 2), $bm_sub($bm_mul($bm_mul($bm_mul(t -= 2, t), t), t), 2)), b);\n}\nfunction easeAndWizz() {\n    var t, d, sX, eX;\n    var n = 0;\n    if (numKeys > 0) {\n        n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    try {\n        var key1 = key(n);\n        var key2 = key($bm_sum(n, 1));\n    } catch (e) {\n        return null;\n    }\n    t = $bm_sub(time, key1.time);\n    d = $bm_sub(key2.time, key1.time);\n    sX = key1.time;\n    eX = $bm_sub(key2.time, key1.time);\n    if (time < key1.time || time > key2.time) {\n        return null;\n    } else {\n        return valueAtTime(easeandwizz_inoutQuart(t, sX, eX, d));\n    }\n}\n$bm_rt = easeAndWizz() || value;",
            },
            r: { a: 0, k: 0, ix: 10 },
            p: {
              a: 0,
              k: [180, 52, 0],
              ix: 2,
              x:
                "var $bm_rt;\nfunction easeandwizz_inoutQuart(t, b, c, d) {\n    if ((t /= d / 2) < 1)\n        return $bm_sum($bm_mul($bm_mul($bm_mul($bm_mul($bm_div(c, 2), t), t), t), t), b);\n    return $bm_sum($bm_mul($bm_div($bm_neg(c), 2), $bm_sub($bm_mul($bm_mul($bm_mul(t -= 2, t), t), t), 2)), b);\n}\nfunction easeAndWizz() {\n    var t, d, sX, eX;\n    var n = 0;\n    if (numKeys > 0) {\n        n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    try {\n        var key1 = key(n);\n        var key2 = key($bm_sum(n, 1));\n    } catch (e) {\n        return null;\n    }\n    t = $bm_sub(time, key1.time);\n    d = $bm_sub(key2.time, key1.time);\n    sX = key1.time;\n    eX = $bm_sub(key2.time, key1.time);\n    if (time < key1.time || time > key2.time) {\n        return null;\n    } else {\n        return valueAtTime(easeandwizz_inoutQuart(t, sX, eX, d));\n    }\n}\n$bm_rt = easeAndWizz() || value;",
            },
            a: { a: 0, k: [196.5, 25.5, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          hasMask: true,
          masksProperties: [
            {
              inv: false,
              mode: "a",
              pt: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [398.5, -1.008],
                    [108.277, -1.008],
                    [108.277, 55.5],
                    [398.5, 55.5],
                  ],
                  c: true,
                },
                ix: 1,
              },
              o: { a: 0, k: 100, ix: 3 },
              x: { a: 0, k: 0, ix: 4 },
              nm: "Mask 1",
            },
          ],
          w: 393,
          h: 51,
          ip: 0,
          op: 1080,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 10,
          ty: 4,
          nm: "Chat 2",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [226, 152.905, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ty: "rc",
                  d: 1,
                  s: { a: 0, k: [338, 302], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 0, ix: 4 },
                  nm: "Rectangle Path 1",
                  mn: "ADBE Vector Shape - Rect",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: {
                    a: 0,
                    k: [0.980392158031, 0.980392158031, 0.980392158031, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Chat",
              np: 2,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 999,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 11,
          ty: 4,
          nm: "Nav 2",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [30, 1.905, 0], ix: 2 },
            a: { a: 0, k: [0, -150.5, 0], ix: 1 },
            s: { a: 0, k: [100, 100.5, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ty: "rc",
                  d: 1,
                  s: { a: 0, k: [54, 301], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 0, ix: 4 },
                  nm: "Rectangle Path 1",
                  mn: "ADBE Vector Shape - Rect",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0, 0.247058823705, 0.180392161012, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Nav",
              np: 2,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 999,
          st: 0,
          bm: 0,
        },
      ],
    },
    {
      id: "comp_1",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 5,
          nm: "Sure thing!",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [81.611, 26.611, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          t: {
            d: {
              k: [
                {
                  s: {
                    sz: [72, 23],
                    ps: [-36, -11.5],
                    s: 14,
                    f: "Inter-Regular",
                    t: "Sure thing!",
                    j: 0,
                    tr: 0,
                    lh: 16.8,
                    ls: 0,
                    fc: [0.17, 0.17, 0.17],
                  },
                  t: 0,
                },
              ],
            },
            p: {},
            m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
            a: [],
          },
          ip: 0,
          op: 936,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "Vector",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [19.97, 20.378, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-1.49, -0.202],
                        [0, 0.612],
                        [5.072, 0],
                        [0.579, -0.115],
                        [-1.635, -0.676],
                        [0, 0],
                        [-0.8, -1.931],
                        [0, 0],
                      ],
                      o: [
                        [0.115, -0.58],
                        [0, -5.073],
                        [-0.615, 0],
                        [0.204, 1.49],
                        [0, 0],
                        [1.933, 0.8],
                        [0, 0],
                        [0.68, 1.642],
                      ],
                      v: [
                        [-0.633, 11.433],
                        [-0.457, 9.643],
                        [-9.639, 0.46],
                        [-11.433, 0.636],
                        [-8.672, 4.2],
                        [-8.527, 4.261],
                        [-4.262, 8.526],
                        [-4.204, 8.667],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-1.49, 0.202],
                        [0, -0.612],
                        [5.072, 0],
                        [0.579, 0.115],
                        [-1.642, 0.678],
                        [0, 0],
                        [-0.798, 1.931],
                        [0, 0],
                      ],
                      o: [
                        [0.115, 0.58],
                        [0, 5.073],
                        [-0.615, 0],
                        [0.204, -1.49],
                        [0, 0],
                        [1.928, -0.8],
                        [0, 0],
                        [0.678, -1.642],
                      ],
                      v: [
                        [-0.633, -11.433],
                        [-0.457, -9.641],
                        [-9.639, -0.458],
                        [-11.433, -0.633],
                        [-8.668, -4.2],
                        [-8.52, -4.261],
                        [-4.26, -8.524],
                        [-4.201, -8.667],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 2",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 2,
                  ty: "sh",
                  ix: 3,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0.8, -1.931],
                        [0, 0],
                        [0, 0],
                        [1.49, -0.202],
                        [0, 0.612],
                        [-5.072, 0],
                        [-0.579, -0.115],
                        [1.64, -0.678],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [-0.678, 1.642],
                        [-0.115, -0.58],
                        [0, -5.073],
                        [0.615, 0],
                        [-0.204, 1.49],
                        [0, 0],
                        [-1.931, 0.8],
                      ],
                      v: [
                        [4.26, 8.526],
                        [4.201, 8.667],
                        [4.201, 8.665],
                        [0.633, 11.431],
                        [0.457, 9.641],
                        [9.639, 0.458],
                        [11.433, 0.633],
                        [8.668, 4.202],
                        [8.525, 4.261],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 3",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 3,
                  ty: "sh",
                  ix: 4,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-0.204, -1.488],
                        [0.615, 0],
                        [0, 0],
                        [0, 5.073],
                        [-0.115, 0.58],
                        [-0.678, -1.642],
                        [0, 0],
                        [-1.931, -0.8],
                        [0, 0],
                      ],
                      o: [
                        [-0.582, 0.115],
                        [0, 0],
                        [-5.072, 0],
                        [0, -0.615],
                        [1.49, 0.202],
                        [0, 0],
                        [0.8, 1.931],
                        [0, 0],
                        [1.642, 0.678],
                      ],
                      v: [
                        [11.433, -0.633],
                        [9.639, -0.458],
                        [9.639, -0.458],
                        [0.457, -9.641],
                        [0.633, -11.433],
                        [4.201, -8.667],
                        [4.26, -8.524],
                        [8.522, -4.261],
                        [8.668, -4.2],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 4",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "mm",
                  mm: 1,
                  nm: "Merge Paths 1",
                  mn: "ADBE Vector Filter - Merge",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.713725507259, 1, 0.501960813999, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Vector",
              np: 6,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 939,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: "sparmark 2",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [19.97, 20.378, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ty: "rc",
                  d: 1,
                  s: { a: 0, k: [22.867, 22.867], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 0, ix: 4 },
                  nm: "Rectangle Path 1",
                  mn: "ADBE Vector Shape - Rect",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "sparmark",
              np: 1,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 939,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: "Avatar 2",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [20.037, 20.444, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ty: "rc",
                  d: 1,
                  s: { a: 0, k: [32.667, 32.667], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 163, ix: 4 },
                  nm: "Rectangle Path 1",
                  mn: "ADBE Vector Shape - Rect",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0, 0.247058823705, 0.180392161012, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Avatar",
              np: 2,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 939,
          st: 0,
          bm: 0,
        },
      ],
    },
    {
      id: "comp_2",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 5,
          nm: "And protect my focus time",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [321.702, 23.348, 0], ix: 2 },
            a: { a: 0, k: [86.498, -5.171, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          t: {
            d: {
              k: [
                {
                  s: {
                    sz: [204.5, 23],
                    ps: [-117, -11.5],
                    s: 14,
                    f: "Inter-Regular",
                    t: "Oh and add Kacy as optional",
                    j: 1,
                    tr: 0,
                    lh: 16.8,
                    ls: 0,
                    fc: [1, 1, 1],
                  },
                  t: 0,
                },
              ],
            },
            p: {},
            m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
            a: [],
          },
          ip: 0,
          op: 1105,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "User Message 4",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [336.204, 23.019, 0], ix: 2 },
            a: { a: 0, k: [101, 0, 0], ix: 1 },
            s: { a: 0, k: [107.178, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ty: "rc",
                  d: 1,
                  s: { a: 0, k: [202, 41], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 11, ix: 4 },
                  nm: "Rectangle Path 1",
                  mn: "ADBE Vector Shape - Rect",
                  hd: false,
                },
                {
                  ty: "gs",
                  o: { a: 0, k: 100, ix: 9 },
                  w: { a: 0, k: 1.134, ix: 10 },
                  g: {
                    p: 3,
                    k: {
                      a: 0,
                      k: [0, 0, 0, 0, 0.5, 0, 0, 0, 1, 0, 0, 0, 0, 0.06, 0.5, 0.04, 1, 0.02],
                      ix: 8,
                    },
                  },
                  s: { a: 0, k: [0, 20.574], ix: 4 },
                  e: { a: 0, k: [0, -20.574], ix: 5 },
                  t: 1,
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  ml2: { a: 0, k: 4, ix: 13 },
                  bm: 0,
                  nm: "Gradient Stroke 1",
                  mn: "ADBE Vector Graphic - G-Stroke",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0, 0.247058823705, 0.180392161012, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "User Message",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 1105,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 2,
          nm: "dan.png",
          cl: "png",
          refId: "image_0",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [361.442, 22.253, 0], ix: 2 },
            a: { a: 0, k: [33, 33, 0], ix: 1 },
            s: { a: 0, k: [50, 50, 100], ix: 6 },
          },
          ao: 0,
          ip: 0,
          op: 1080,
          st: 0,
          bm: 0,
        },
      ],
    },
    {
      id: "comp_3",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 5,
          nm: "But after daycare drop-off",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [243.704, 28.37, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          t: {
            d: {
              k: [
                {
                  s: {
                    sz: [174, 23],
                    ps: [-87, -11.5],
                    s: 14,
                    f: "Inter-Regular",
                    t: "On Monday or Tuesday",
                    j: 1,
                    tr: 0,
                    lh: 16.8,
                    ls: 0,
                    fc: [1, 1, 1],
                  },
                  t: 0,
                },
              ],
            },
            p: {},
            m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
            a: [],
          },
          ip: 0,
          op: 1198,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "User Message 5",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [344.204, 22.87, 0], ix: 2 },
            a: { a: 0, k: [100.5, 0, 0], ix: 1 },
            s: { a: 0, k: [89.552, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ty: "rc",
                  d: 1,
                  s: { a: 0, k: [201, 41], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 11, ix: 4 },
                  nm: "Rectangle Path 1",
                  mn: "ADBE Vector Shape - Rect",
                  hd: false,
                },
                {
                  ty: "gs",
                  o: { a: 0, k: 100, ix: 9 },
                  w: { a: 0, k: 1.134, ix: 10 },
                  g: {
                    p: 3,
                    k: {
                      a: 0,
                      k: [0, 0, 0, 0, 0.5, 0, 0, 0, 1, 0, 0, 0, 0, 0.06, 0.5, 0.04, 1, 0.02],
                      ix: 8,
                    },
                  },
                  s: { a: 0, k: [0, 20.574], ix: 4 },
                  e: { a: 0, k: [0, -20.574], ix: 5 },
                  t: 1,
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  ml2: { a: 0, k: 4, ix: 13 },
                  bm: 0,
                  nm: "Gradient Stroke 1",
                  mn: "ADBE Vector Graphic - G-Stroke",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0, 0.247058823705, 0.180392161012, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "User Message",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 1198,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 2,
          nm: "dan.png",
          cl: "png",
          refId: "image_0",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [369.442, 22.72, 0], ix: 2 },
            a: { a: 0, k: [33, 33, 0], ix: 1 },
            s: { a: 0, k: [50, 50, 100], ix: 6 },
          },
          ao: 0,
          ip: 0,
          op: 1080,
          st: 0,
          bm: 0,
        },
      ],
    },
    {
      id: "comp_4",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 2,
          nm: "dan.png",
          cl: "png",
          refId: "image_0",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [371.442, 25.874, 0], ix: 2 },
            a: { a: 0, k: [33, 33, 0], ix: 1 },
            s: { a: 0, k: [50, 50, 100], ix: 6 },
          },
          ao: 0,
          ip: 0,
          op: 1080,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 5,
          nm: "Schedule a meeting with Emily",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [231.704, 31.222, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          t: {
            d: {
              k: [
                {
                  s: {
                    sz: [202, 23],
                    ps: [-101, -11.5],
                    s: 14,
                    f: "Inter-Regular",
                    t: "Schedule a meeting with Emily",
                    j: 0,
                    tr: 0,
                    lh: 16.8,
                    ls: 0,
                    fc: [1, 1, 1],
                  },
                  t: 0,
                },
              ],
            },
            p: {},
            m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
            a: [],
          },
          ip: 0,
          op: 1156,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: "User Message 6",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [231.704, 25.722, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ty: "rc",
                  d: 1,
                  s: { a: 0, k: [229, 41], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 11, ix: 4 },
                  nm: "Rectangle Path 1",
                  mn: "ADBE Vector Shape - Rect",
                  hd: false,
                },
                {
                  ty: "gs",
                  o: { a: 0, k: 100, ix: 9 },
                  w: { a: 0, k: 1.134, ix: 10 },
                  g: {
                    p: 3,
                    k: {
                      a: 0,
                      k: [0, 0, 0, 0, 0.5, 0, 0, 0, 1, 0, 0, 0, 0, 0.06, 0.5, 0.04, 1, 0.02],
                      ix: 8,
                    },
                  },
                  s: { a: 0, k: [0, 20.574], ix: 4 },
                  e: { a: 0, k: [0, -20.574], ix: 5 },
                  t: 1,
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  ml2: { a: 0, k: 4, ix: 13 },
                  bm: 0,
                  nm: "Gradient Stroke 1",
                  mn: "ADBE Vector Graphic - G-Stroke",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0, 0.247058823705, 0.180392161012, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "User Message",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 1156,
          st: 0,
          bm: 0,
        },
      ],
    },
    {
      id: "animation-07630f30",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 0,
          nm: "ai-beta-chat",
          refId: "comp_0",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [450, 350, 0], ix: 2 },
            a: { a: 0, k: [198, 153, 0], ix: 1 },
            s: { a: 0, k: [200, 200, 100], ix: 6 },
          },
          ao: 0,
          ef: [
            {
              ty: 5,
              nm: "Simple Choker",
              np: 4,
              mn: "ADBE Simple Choker",
              ix: 1,
              en: 1,
              ef: [
                {
                  ty: 7,
                  nm: "View",
                  mn: "ADBE Simple Choker-0001",
                  ix: 1,
                  v: { a: 0, k: 1, ix: 1 },
                },
                {
                  ty: 0,
                  nm: "Choke Matte",
                  mn: "ADBE Simple Choker-0002",
                  ix: 2,
                  v: { a: 0, k: 10, ix: 2 },
                },
              ],
            },
            {
              ty: 5,
              nm: "Simple Choker 2",
              np: 4,
              mn: "ADBE Simple Choker",
              ix: 2,
              en: 1,
              ef: [
                {
                  ty: 7,
                  nm: "View",
                  mn: "ADBE Simple Choker-0001",
                  ix: 1,
                  v: { a: 0, k: 1, ix: 1 },
                },
                {
                  ty: 0,
                  nm: "Choke Matte",
                  mn: "ADBE Simple Choker-0002",
                  ix: 2,
                  v: { a: 0, k: -10, ix: 2 },
                },
              ],
            },
          ],
          w: 396,
          h: 306,
          ip: 0,
          op: 1080,
          st: 0,
          bm: 0,
        },
      ],
    },
  ],
  fonts: {
    list: [
      {
        fName: "Inter-Regular",
        fFamily: "Inter",
        fStyle: "Regular",
        ascent: 72.7249145507812,
      },
    ],
  },
  layers: [
    {
      ddd: 0,
      ind: 0,
      ty: 0,
      nm: "Precomp Layer",
      refId: "animation-07630f30",
      ks: {
        a: { a: 0, k: [0, 0] },
        p: { a: 0, k: [-60, -49.25001255587364] },
        s: { a: 0, k: [100, 100] },
        r: { a: 0, k: 0 },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      fr: 60,
      w: 900,
      h: 700,
      ip: 0,
      op: 400,
      st: 0,
    },
  ],
  markers: [],
  chars: [
    {
      ch: "S",
      size: 14,
      style: "Regular",
      w: 63.78,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-0.842, -7.089],
                      [0, 0],
                      [13.898, 0],
                      [0, -12.073],
                      [-11.23, -3.229],
                      [0, 0],
                      [0, -7.159],
                      [9.967, 0],
                      [0.702, 8.142],
                      [0, 0],
                      [-15.442, 0],
                      [0, 11.652],
                      [7.44, 1.965],
                      [0, 0],
                      [0, 7.721],
                      [-9.546, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.386, -10.844],
                      [-13.757, 0],
                      [0, 9.686],
                      [0, 0],
                      [7.581, 2.106],
                      [0, 7.861],
                      [-8.563, 0],
                      [0, 0],
                      [0.842, 11.792],
                      [16.565, 0],
                      [0, -13.477],
                      [0, 0],
                      [-5.334, -1.404],
                      [0, -6.879],
                      [8.704, 0],
                    ],
                    v: [
                      [48.01, -53.906],
                      [56.433, -53.906],
                      [32.147, -72.858],
                      [7.581, -52.783],
                      [25.83, -34.113],
                      [34.674, -31.586],
                      [48.993, -19.653],
                      [31.445, -6.598],
                      [14.6, -18.53],
                      [5.615, -18.53],
                      [31.445, 1.263],
                      [57.416, -19.513],
                      [37.201, -39.307],
                      [29.901, -41.272],
                      [16.003, -53.204],
                      [31.866, -65.137],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "S",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "S",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "c",
      size: 14,
      style: "Regular",
      w: 55.82,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-15.161, 0],
                      [-1.404, 9.546],
                      [0, 0],
                      [6.458, 0],
                      [0, 12.494],
                      [-9.686, 0],
                      [-1.263, -4.913],
                      [0, 0],
                      [11.371, 0],
                      [0, -16.425],
                    ],
                    o: [
                      [11.932, 0],
                      [0, 0],
                      [-1.544, 5.896],
                      [-9.827, 0],
                      [0, -12.213],
                      [7.3, 0],
                      [0, 0],
                      [-1.404, -10.107],
                      [-14.6, 0],
                      [0, 16.144],
                    ],
                    v: [
                      [29.48, 1.123],
                      [50.677, -15.723],
                      [42.395, -15.723],
                      [29.48, -6.317],
                      [13.336, -26.953],
                      [29.48, -47.168],
                      [42.395, -37.762],
                      [50.677, -37.762],
                      [29.34, -54.608],
                      [5.054, -26.672],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "c",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "c",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "h",
      size: 14,
      style: "Regular",
      w: 59.09,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-8.177, 0],
                      [0, -8.563],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [11.02, 0],
                      [2.527, -5.58],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, -9.406],
                      [7.791, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -13.863],
                      [-8.493, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.863, -32.428],
                      [30.042, -47.168],
                      [42.535, -33.691],
                      [42.535, 0],
                      [50.818, 0],
                      [50.818, -34.253],
                      [32.428, -54.608],
                      [16.565, -45.483],
                      [15.863, -45.483],
                      [15.863, -71.875],
                      [7.581, -71.875],
                      [7.581, 0],
                      [15.863, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "h",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "h",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "e",
      size: 14,
      style: "Regular",
      w: 58.24,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-15.582, 0],
                      [-2.527, 8.142],
                      [0, 0],
                      [6.493, 0],
                      [0.386, 11.546],
                      [0, 0],
                      [0, 0],
                      [11.23, 0],
                      [0, -16.565],
                    ],
                    o: [
                      [10.95, 0],
                      [0, 0],
                      [-2.106, 5.615],
                      [-9.721, 0],
                      [0, 0],
                      [0, 0],
                      [0, -20.074],
                      [-14.6, 0],
                      [0, 16.565],
                    ],
                    v: [
                      [30.182, 1.123],
                      [51.66, -12.494],
                      [43.658, -14.74],
                      [30.182, -6.317],
                      [13.371, -24.146],
                      [52.502, -24.146],
                      [52.502, -27.655],
                      [29.34, -54.608],
                      [5.054, -26.532],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "e",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-9.476, 0],
                      [0, -9.125],
                    ],
                    o: [
                      [0.562, -8.388],
                      [8.984, 0],
                      [0, 0],
                    ],
                    v: [
                      [13.371, -31.305],
                      [29.34, -47.168],
                      [44.08, -31.305],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "e",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "e",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "d",
      size: 14,
      style: "Regular",
      w: 62.07,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-13.477, 0],
                      [-1.825, 2.948],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [10.529, 0],
                      [0, -16.986],
                    ],
                    o: [
                      [10.388, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-1.825, -2.808],
                      [-13.617, 0],
                      [0, 17.126],
                    ],
                    v: [
                      [27.936, 1.123],
                      [43.658, -8.282],
                      [44.641, -8.282],
                      [44.641, 0],
                      [52.643, 0],
                      [52.643, -71.875],
                      [44.36, -71.875],
                      [44.36, -45.343],
                      [43.658, -45.343],
                      [28.076, -54.608],
                      [5.054, -26.813],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "d",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [9.967, 0],
                      [0, 11.511],
                      [-10.529, 0],
                      [0, -12.073],
                    ],
                    o: [
                      [-10.388, 0],
                      [0, -11.371],
                      [10.107, 0],
                      [0, 12.213],
                    ],
                    v: [
                      [29.059, -6.317],
                      [13.336, -26.953],
                      [29.059, -47.168],
                      [44.501, -26.953],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "d",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "d",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "u",
      size: 14,
      style: "Regular",
      w: 58.1,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [6.177, 0],
                      [0, 7.861],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-10.107, 0],
                      [-2.527, 5.475],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 10.107],
                      [-6.879, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 13.757],
                      [8.142, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [41.553, -22.04],
                      [27.655, -7.3],
                      [15.863, -20.215],
                      [15.863, -53.906],
                      [7.581, -53.906],
                      [7.581, -19.653],
                      [24.988, 0.702],
                      [40.991, -9.125],
                      [41.553, -9.125],
                      [41.553, 0],
                      [49.835, 0],
                      [49.835, -53.906],
                      [41.553, -53.906],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "u",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "u",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "l",
      size: 14,
      style: "Regular",
      w: 23.72,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.863, -71.875],
                      [7.581, -71.875],
                      [7.581, 0],
                      [15.863, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "l",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "l",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    { ch: " ", size: 14, style: "Regular", w: 28.12, data: {}, fFamily: "Inter" },
    {
      ch: "a",
      size: 14,
      style: "Regular",
      w: 56.39,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-10.248, 0],
                      [-1.685, 3.51],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [6.879, 0],
                      [4.211, -9.827],
                      [0, 0],
                      [-7.896, 0],
                      [0, -6.914],
                      [0, 0],
                      [9.827, -1.263],
                      [0, -12.354],
                    ],
                    o: [
                      [9.406, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -17.126],
                      [-8.142, 0],
                      [0, 0],
                      [1.825, -3.931],
                      [7.616, 0],
                      [0, 0],
                      [0, 4.001],
                      [-10.002, 1.299],
                      [0, 10.529],
                    ],
                    v: [
                      [23.444, 1.263],
                      [39.447, -7.3],
                      [39.868, -7.3],
                      [39.868, 0],
                      [48.151, 0],
                      [48.151, -35.516],
                      [28.217, -54.608],
                      [6.598, -41.974],
                      [14.459, -39.166],
                      [28.497, -47.308],
                      [39.868, -36.359],
                      [39.868, -36.078],
                      [25.97, -31.165],
                      [5.054, -15.302],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "a",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [9.827, 0],
                      [0, 5.756],
                      [-6.458, 0.842],
                      [-1.404, 1.685],
                      [0, 0],
                    ],
                    o: [
                      [-6.598, 0],
                      [0, -6.317],
                      [3.51, -0.421],
                      [0, 0],
                      [0, 6.738],
                    ],
                    v: [
                      [24.707, -6.177],
                      [13.336, -14.88],
                      [25.549, -24.005],
                      [39.868, -27.094],
                      [39.868, -19.513],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "a",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "a",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "m",
      size: 14,
      style: "Regular",
      w: 86.93,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-6.458, 0],
                      [0, -6.142],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-7.581, 0],
                      [0, -7.967],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [9.616, 0],
                      [2.773, -5.58],
                      [0, 0],
                      [7.089, 0],
                      [2.246, -5.756],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, -7.896],
                      [6.282, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.949],
                      [5.896, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -12.669],
                      [-7.721, 0],
                      [0, 0],
                      [-2.667, -5.756],
                      [-7.019, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [7.581, 0],
                      [15.863, 0],
                      [15.863, -33.691],
                      [28.076, -47.168],
                      [38.745, -36.92],
                      [38.745, 0],
                      [47.168, 0],
                      [47.168, -35.095],
                      [59.1, -47.168],
                      [70.05, -36.078],
                      [70.05, 0],
                      [78.333, 0],
                      [78.333, -36.078],
                      [61.908, -54.608],
                      [45.764, -45.483],
                      [45.203, -45.483],
                      [30.743, -54.608],
                      [16.284, -45.483],
                      [15.582, -45.483],
                      [15.582, -53.906],
                      [7.581, -53.906],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "m",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "m",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "t",
      size: 14,
      style: "Regular",
      w: 36.36,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-7.019, 0],
                      [-1.123, 0.421],
                      [0, 0],
                      [1.825, 0],
                      [0, 7.019],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 9.406],
                      [3.088, 0],
                      [0, 0],
                      [-0.702, 0.14],
                      [-3.65, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [31.024, -53.906],
                      [19.513, -53.906],
                      [19.513, -66.821],
                      [11.23, -66.821],
                      [11.23, -53.906],
                      [3.088, -53.906],
                      [3.088, -46.887],
                      [11.23, -46.887],
                      [11.23, -13.196],
                      [25.83, 0.702],
                      [32.007, -0.281],
                      [30.322, -7.721],
                      [26.672, -7.3],
                      [19.513, -15.442],
                      [19.513, -46.887],
                      [31.024, -46.887],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "t",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "t",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "i",
      size: 14,
      style: "Regular",
      w: 23.72,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [7.581, 0],
                      [15.863, 0],
                      [15.863, -53.906],
                      [7.581, -53.906],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "i",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-3.229, 0],
                      [0, 3.088],
                      [3.229, 0],
                      [0, -3.088],
                    ],
                    o: [
                      [3.229, 0],
                      [0, -3.088],
                      [-3.229, 0],
                      [0, 3.088],
                    ],
                    v: [
                      [11.792, -62.891],
                      [17.688, -68.506],
                      [11.792, -74.121],
                      [5.896, -68.506],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "i",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "i",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "n",
      size: 14,
      style: "Regular",
      w: 58.52,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-7.932, 0],
                      [0, -8.458],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [10.915, 0],
                      [2.527, -5.475],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, -9.406],
                      [7.686, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -13.757],
                      [-8.142, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.863, -32.428],
                      [29.62, -47.168],
                      [41.974, -33.691],
                      [41.974, 0],
                      [50.256, 0],
                      [50.256, -34.253],
                      [32.007, -54.608],
                      [16.284, -45.483],
                      [15.582, -45.483],
                      [15.582, -53.906],
                      [7.581, -53.906],
                      [7.581, 0],
                      [15.863, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "n",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "n",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "g",
      size: 14,
      style: "Regular",
      w: 60.94,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-12.038, 0],
                      [0, 13.898],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [10.529, 0],
                      [0, -16.565],
                      [-13.055, 0],
                      [-1.825, 2.948],
                      [0, 0],
                      [0, 0],
                      [8.704, 0],
                      [2.211, 2.983],
                      [0, 0],
                    ],
                    o: [
                      [12.915, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-1.825, -2.808],
                      [-13.617, 0],
                      [0, 16.846],
                      [10.529, 0],
                      [0, 0],
                      [0, 0],
                      [0, 8.984],
                      [-9.792, 0],
                      [0, 0],
                      [3.369, 5.65],
                    ],
                    v: [
                      [29.34, 21.338],
                      [52.643, 1.544],
                      [52.643, -53.906],
                      [44.641, -53.906],
                      [44.641, -45.343],
                      [43.799, -45.343],
                      [28.076, -54.608],
                      [5.054, -27.234],
                      [27.936, -0.842],
                      [43.658, -9.967],
                      [44.36, -9.967],
                      [44.36, 0.983],
                      [29.34, 14.038],
                      [13.898, 5.896],
                      [7.3, 10.529],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "g",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [9.967, 0],
                      [0, 11.23],
                      [-10.529, 0],
                      [0, -11.652],
                    ],
                    o: [
                      [-10.388, 0],
                      [0, -10.95],
                      [10.107, 0],
                      [0, 11.932],
                    ],
                    v: [
                      [29.059, -8.282],
                      [13.336, -27.374],
                      [29.059, -47.168],
                      [44.501, -27.374],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "g",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "g",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "w",
      size: 14,
      style: "Regular",
      w: 81.25,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [19.794, 0],
                      [27.936, 0],
                      [39.728, -41.412],
                      [40.57, -41.412],
                      [52.362, 0],
                      [60.504, 0],
                      [76.929, -53.906],
                      [68.225, -53.906],
                      [56.573, -12.775],
                      [56.012, -12.775],
                      [44.641, -53.906],
                      [35.797, -53.906],
                      [24.286, -12.634],
                      [23.724, -12.634],
                      [12.073, -53.906],
                      [3.369, -53.906],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "w",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "w",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "E",
      size: 14,
      style: "Regular",
      w: 59.8,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [8.704, 0],
                      [52.643, 0],
                      [52.643, -7.721],
                      [17.407, -7.721],
                      [17.407, -32.147],
                      [49.835, -32.147],
                      [49.835, -39.868],
                      [17.407, -39.868],
                      [17.407, -64.154],
                      [52.081, -64.154],
                      [52.081, -71.875],
                      [8.704, -71.875],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "E",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "E",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "y",
      size: 14,
      style: "Regular",
      w: 55.68,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-2.808, 0],
                      [-3.123, 8.388],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [6.036, 1.544],
                      [0, 0],
                    ],
                    o: [
                      [7.475, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-3.018, 8.212],
                      [0, 0],
                      [0.842, 0.421],
                    ],
                    v: [
                      [12.915, 20.215],
                      [28.778, 7.861],
                      [51.66, -53.906],
                      [42.676, -53.906],
                      [27.795, -10.95],
                      [27.234, -10.95],
                      [12.354, -53.906],
                      [3.369, -53.906],
                      [23.303, 0.281],
                      [21.759, 4.492],
                      [8.984, 11.932],
                      [6.879, 19.232],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "y",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "y",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "O",
      size: 14,
      style: "Regular",
      w: 76.14,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 22.742],
                      [18.39, 0],
                      [0, -22.742],
                      [-18.39, 0],
                    ],
                    o: [
                      [0, -22.742],
                      [-18.39, 0],
                      [0, 22.742],
                      [18.39, 0],
                    ],
                    v: [
                      [69.348, -35.938],
                      [37.622, -72.858],
                      [5.896, -35.938],
                      [37.622, 0.983],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "O",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, -18.671],
                      [13.055, 0],
                      [0, 18.671],
                      [-13.055, 0],
                    ],
                    o: [
                      [0, 18.671],
                      [-13.055, 0],
                      [0, -18.671],
                      [13.055, 0],
                    ],
                    v: [
                      [60.925, -35.938],
                      [37.622, -7.159],
                      [14.319, -35.938],
                      [37.622, -64.716],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "O",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "O",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "M",
      size: 14,
      style: "Regular",
      w: 88.92,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [8.704, -71.875],
                      [8.704, 0],
                      [16.846, 0],
                      [16.846, -54.608],
                      [17.548, -54.608],
                      [40.009, 0],
                      [47.87, 0],
                      [70.331, -54.608],
                      [71.033, -54.608],
                      [71.033, 0],
                      [79.175, 0],
                      [79.175, -71.875],
                      [68.787, -71.875],
                      [44.36, -12.213],
                      [43.518, -12.213],
                      [19.092, -71.875],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "M",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "M",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "o",
      size: 14,
      style: "Regular",
      w: 59.66,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-14.6, 0],
                      [0, 16.705],
                      [14.6, 0],
                      [0, -16.846],
                    ],
                    o: [
                      [14.6, 0],
                      [0, -16.846],
                      [-14.6, 0],
                      [0, 16.705],
                    ],
                    v: [
                      [29.48, 1.123],
                      [53.906, -26.672],
                      [29.48, -54.608],
                      [5.054, -26.672],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "o",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [11.09, 0],
                      [0, 10.809],
                      [-11.09, 0],
                      [0, -10.809],
                    ],
                    o: [
                      [-11.09, 0],
                      [0, -10.809],
                      [11.09, 0],
                      [0, 10.809],
                    ],
                    v: [
                      [29.48, -6.317],
                      [13.336, -26.672],
                      [29.48, -47.168],
                      [45.624, -26.672],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "o",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "o",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "r",
      size: 14,
      style: "Regular",
      w: 37.22,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-7.861, 0],
                      [-0.562, -0.14],
                      [0, 0],
                      [1.228, 0],
                      [1.965, -5.334],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, -7.3],
                      [2.211, 0],
                      [0, 0],
                      [-0.948, -0.07],
                      [-6.458, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [7.581, 0],
                      [15.863, 0],
                      [15.863, -34.113],
                      [29.48, -46.747],
                      [34.534, -46.185],
                      [34.534, -54.608],
                      [30.182, -54.749],
                      [16.144, -45.764],
                      [15.582, -45.764],
                      [15.582, -53.906],
                      [7.581, -53.906],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "r",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "r",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "T",
      size: 14,
      style: "Regular",
      w: 64.2,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [4.773, -64.154],
                      [27.374, -64.154],
                      [27.374, 0],
                      [36.078, 0],
                      [36.078, -64.154],
                      [58.679, -64.154],
                      [58.679, -71.875],
                      [4.773, -71.875],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "T",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "T",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "s",
      size: 14,
      style: "Regular",
      w: 52.27,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [10.669, 0],
                      [0, -9.125],
                      [-9.897, -2.316],
                      [0, 0],
                      [0, -3.72],
                      [7.721, 0],
                      [1.474, 5.791],
                      [0, 0],
                      [-11.02, 0],
                      [0, 9.3],
                      [9.616, 2.351],
                      [0, 0],
                      [0, 4.141],
                      [-6.598, 0],
                      [-1.439, -3.72],
                    ],
                    o: [
                      [-2.597, -7.651],
                      [-11.371, 0],
                      [0, 7.44],
                      [0, 0],
                      [5.44, 1.263],
                      [0, 4.633],
                      [-6.773, 0],
                      [0, 0],
                      [1.93, 9.16],
                      [12.529, 0],
                      [0, -7.51],
                      [0, 0],
                      [-6.387, -1.579],
                      [0, -4.633],
                      [7.23, 0],
                      [0, 0],
                    ],
                    v: [
                      [45.764, -41.833],
                      [26.672, -54.608],
                      [6.879, -39.026],
                      [21.198, -24.286],
                      [30.182, -22.18],
                      [38.184, -14.6],
                      [25.549, -6.177],
                      [13.055, -14.88],
                      [5.194, -12.915],
                      [25.69, 1.123],
                      [46.747, -15.021],
                      [32.428, -29.62],
                      [24.426, -31.586],
                      [15.161, -39.447],
                      [26.672, -47.449],
                      [38.324, -39.728],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "s",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "s",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "K",
      size: 14,
      style: "Regular",
      w: 65.2,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [8.704, 0],
                      [17.407, 0],
                      [17.407, -23.303],
                      [26.392, -33.411],
                      [51.379, 0],
                      [61.908, 0],
                      [31.726, -39.447],
                      [61.908, -71.875],
                      [50.537, -71.875],
                      [18.25, -36.218],
                      [17.407, -36.218],
                      [17.407, -71.875],
                      [8.704, -71.875],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "K",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "K",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "p",
      size: 14,
      style: "Regular",
      w: 60.94,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-10.388, 0],
                      [0, 17.126],
                      [13.617, 0],
                      [1.825, -2.808],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.825, 2.948],
                      [13.477, 0],
                      [0, -16.986],
                      [-10.529, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [7.581, 20.215],
                      [15.863, 20.215],
                      [15.863, -8.282],
                      [16.565, -8.282],
                      [32.288, 1.123],
                      [55.17, -26.813],
                      [32.147, -54.608],
                      [16.565, -45.343],
                      [15.582, -45.343],
                      [15.582, -53.906],
                      [7.581, -53.906],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "p",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 12.213],
                      [-10.107, 0],
                      [0, -11.371],
                      [10.388, 0],
                    ],
                    o: [
                      [0, -12.073],
                      [10.529, 0],
                      [0, 11.511],
                      [-9.967, 0],
                    ],
                    v: [
                      [15.723, -26.953],
                      [31.165, -47.168],
                      [46.887, -26.953],
                      [31.165, -6.317],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "p",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "p",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "!",
      size: 14,
      style: "Regular",
      w: 27.84,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [18.53, -71.875],
                      [8.984, -71.875],
                      [9.686, -20.215],
                      [17.828, -20.215],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "!",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-3.474, 0],
                      [0, 3.474],
                      [3.474, 0],
                      [0, -3.474],
                    ],
                    o: [
                      [3.474, 0],
                      [0, -3.474],
                      [-3.474, 0],
                      [0, 3.474],
                    ],
                    v: [
                      [13.757, 0.562],
                      [20.074, -5.756],
                      [13.757, -12.073],
                      [7.44, -5.756],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "!",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "!",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
  ],
};

export default AIExample;
